import React, {useCallback, useEffect, useMemo, useState} from "react";
import {Divider, Form, Loader, SelectPicker} from "rsuite";
import {getUsers} from "../../../../service/adminService";
import UserEditNav from "../../../nav/UserEditNav";
import UserEditSkills from "../userEditPages/UserEditSkills";
import UserEditExperience from "../userEditPages/UserEditExperience";
import UserEditProjects from "../userEditPages/UserEditProjects";
import UserEditEducation from "../userEditPages/UserEditEducation";
import UserEditCertifications from "../userEditPages/UserEditCertifications";

const UserEdit = () => {

    const [active, setActive] = useState('skills');
    const [loading, setLoading] = useState(false);

    const [users, setUsers] = useState([]);
    const [usersForDropDown, setUsersForDropdown] = useState([]);
    const [selectedUser, setSelectedUser] = useState({});

    const renderPage = useMemo(() => {
        switch (active) {
            case 'skills':
                return <UserEditSkills selectedUser={selectedUser} />;
            case 'experience':
                return <UserEditExperience selectedUser={selectedUser} />;
            case 'projects':
                return <UserEditProjects selectedUser={selectedUser} />;
            case 'education':
                return <UserEditEducation selectedUser={selectedUser} />;
            case 'certifications':
                return <UserEditCertifications selectedUser={selectedUser} />;
            default:
                break; //do nothing
        }
    }, [active, selectedUser]);


    const loadUserObjectOnSelect = useCallback((email) => {
        const user = users.find((user) => user.email === email);
        setSelectedUser(user);
    }, [users]);

    // load all user information
    useEffect(() => {
        setLoading(true);
        getUsers().then((users) => {
            setUsers(users);
            setUsersForDropdown(users.map(ele => ({label: `${ele.lastName}, ${ele.firstName}`, value: ele.email})));
            setLoading(false);
        });
    }, []);

    return useMemo(() => {
        return (
            <div className="main-content">
                {loading ? <Loader/> :
                    <>
                <Form
                    layout="inline"
                >
                    <Form.Group>
                        <Form.ControlLabel>Select User To Edit</Form.ControlLabel>
                        <Form.Control name="users"
                                      accepter={SelectPicker}
                                      data={usersForDropDown}
                                      onChange={loadUserObjectOnSelect}
                        />
                    </Form.Group>
                </Form>
                <Divider style={{marginTop: '0rem'}}/>
                {selectedUser?.email === undefined ? null :
                    <>
                        <UserEditNav appearance="tabs" active={active} onSelect={setActive}/>
                        {renderPage}
                    </>
                }
                </>}
            </div>
        );
    }, [
        active,
        loading,
        loadUserObjectOnSelect,
        renderPage,
        selectedUser,
        usersForDropDown]);
};

export default UserEdit;